import { scorePassword } from '@disco/utils/password'
import React from 'react'
import type { PasswordStrength } from 'types/business'
import { Box, Progress, Text } from 'components/ds'
const strength = ['Very weak', 'Weak', 'Decent', 'Strong', 'Very strong']
const strengthColors = ['red', 'orange', 'yellow', 'jade', 'grass'] as const
type Props = {
  password: string
  passwordStrength: PasswordStrength
  error?: React.ReactNode
}

/**
 * Password strength indicator component with visual progress bar and strength labels
 * Displays password strength scoring with color-coded progress and descriptive text
 * @param password - Password string to evaluate
 * @param passwordStrength - Business password strength requirements
 * @param error - Optional error message to display instead of strength indicator
 */
const PasswordStrengthIndicator = (props: Props): React.ReactNode => {
  if (props.error) return props.error
  const passwordScore = scorePassword(props.password, props.passwordStrength)
  let strengthIndex = Math.floor(passwordScore / (100 / strength.length))
  strengthIndex = strengthIndex > 4 ? 4 : strengthIndex
  const strengthCaption =
    passwordScore === 0 ? 'Strength' : strength[strengthIndex]
  const strengthColor = strengthColors[strengthIndex]
  return (
    <Box mt="1">
      <Progress value={passwordScore * 0.72} color={strengthColor} />
      <Text size="1" color="gray">
        {strengthCaption}
      </Text>
    </Box>
  )
}

export default PasswordStrengthIndicator
